import api from "./Api";

class ReceberAnexoService {
  GetReceberAnexo(payload) {
    return api.get("/v1/receberAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostReceberAnexo(payload) {
    return api.post("/v1/receberAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  PutReceberAnexo(payload) {
    return api.put("/v1/receberAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteReceberAnexo(payload) {
    return api.delete("/v1/receberAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetReceberAnexoOData(payload) {
    return api.get("/OData/ReceberAnexo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ReceberAnexoService();
